import { IconButton, styled } from "@mui/material";

export const StyledPuestos = {
    Container: styled("div")(({ theme }) => ({
        display: "flex",
        alignItems: "flex-end",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
        flexWrap: "nowrap",
    })),
    InputContainer: styled("div")(() => ({
        flex: 1
    })),
    IconButton: styled(IconButton)(({ theme }) => ({
        minWidth: 40,
        height: 40,
        alignSelf: "flex-end",
        marginBottom: theme.spacing(0.5),
    }))
}